import { Remote, wrap } from "comlink"
import { writeFile } from "xlsx"
import * as streamsaver from "streamsaver"

import { errorService } from "infrastructure/services/ErrorService"

import { TCreateXLSXWorker } from "./createXLSX.worker"

const columnsTypeNumeric = [
  "Client pay amount",
  "Client get amount",
  "Client pay system amount",
  "Operations started",
  "Operations fail",
  "Operations success",
  "PNL Expected",
  "PNL Success",
  "PNL Fail",
]

type TReader = {
  read: () => Promise<{ done: boolean; value: ArrayBufferView | ArrayBuffer }>
}

export const downloaders = {
  XLSX: async (fileName: string, reader: TReader): Promise<void> => {
    const decoder = new TextDecoder()
    let data = ""
    let isStreamEnded = false
    while (!isStreamEnded) {
      // eslint-disable-next-line no-await-in-loop
      const { value, done } = await reader.read()
      isStreamEnded = done

      if (value) {
        const chunk = decoder.decode(value, { stream: true })
        data += chunk
      }
    }

    const worker = new Worker(new URL("createXLSX.worker.ts", import.meta.url))
    const createXLSXWorker = wrap<Remote<TCreateXLSXWorker>>(worker)
    const [workbook, error] = await createXLSXWorker(data, columnsTypeNumeric)
    worker.terminate()
    if (error) errorService.send(error)
    if (workbook) writeFile(workbook, `${fileName}.xlsx`)
  },

  CSV: async (fileName: string, reader: TReader): Promise<void> => {
    const writer = streamsaver.createWriteStream(`${fileName}.csv`).getWriter()

    let isStreamEnded = false
    while (!isStreamEnded) {
      // eslint-disable-next-line no-await-in-loop
      const { value, done } = await reader.read()
      isStreamEnded = done

      if (value) writer.write(value)
    }

    writer.close()
  },
}
